import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.string.iterator.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.array.map.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.regexp.match.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import Vue from 'vue';
import fetch from 'unfetch';
import middleware from './middleware.js';
import { applyAsyncData, promisify, middlewareSeries, sanitizeComponent, resolveRouteComponents, getMatchedComponents, getMatchedComponentsInstances, flatMapComponents, setContext, getLocation, compile, getQueryDiff, globalHandleError, isSamePath } from './utils.js';
import { createApp, NuxtError } from './index.js';
import fetchMixin from './mixins/fetch.client';
import NuxtLink from './components/nuxt-link.client.js'; // should be included after ./index.js

// Fetch mixin
if (!Vue.__nuxt__fetch__mixin__) {
  Vue.mixin(fetchMixin);
  Vue.__nuxt__fetch__mixin__ = true;
}

// Component: <NuxtLink>
Vue.component(NuxtLink.name, NuxtLink);
Vue.component('NLink', NuxtLink);
if (!global.fetch) {
  global.fetch = fetch;
}

// Global shared references
var _lastPaths = [];
var app;
var router;
var store;

// Try to rehydrate SSR data from window
var NUXT = window.__NUXT__ || {};
Object.assign(Vue.config, {
  "silent": true,
  "performance": false
});
var errorHandler = Vue.config.errorHandler || console.error;

// Create and mount App
createApp(null, NUXT.config).then(mountApp).catch(errorHandler);
function componentOption(component, key) {
  if (!component || !component.options || !component.options[key]) {
    return {};
  }
  var option = component.options[key];
  if (typeof option === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return option.apply(void 0, args);
  }
  return option;
}
function mapTransitions(toComponents, to, from) {
  var componentTransitions = function componentTransitions(component) {
    var transition = componentOption(component, 'transition', to, from) || {};
    return typeof transition === 'string' ? {
      name: transition
    } : transition;
  };
  var fromComponents = from ? getMatchedComponents(from) : [];
  var maxDepth = Math.max(toComponents.length, fromComponents.length);
  var mergedTransitions = [];
  var _loop = function _loop() {
    // Clone original objects to prevent overrides
    var toTransitions = Object.assign({}, componentTransitions(toComponents[i]));
    var transitions = Object.assign({}, componentTransitions(fromComponents[i]));

    // Combine transitions & prefer `leave` properties of "from" route
    Object.keys(toTransitions).filter(function (key) {
      return typeof toTransitions[key] !== 'undefined' && !key.toLowerCase().includes('leave');
    }).forEach(function (key) {
      transitions[key] = toTransitions[key];
    });
    mergedTransitions.push(transitions);
  };
  for (var i = 0; i < maxDepth; i++) {
    _loop();
  }
  return mergedTransitions;
}
function loadAsyncComponents(_x, _x2, _x3) {
  return _loadAsyncComponents.apply(this, arguments);
}
function _loadAsyncComponents() {
  _loadAsyncComponents = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(to, from, next) {
    var _this3 = this;
    var Components, startLoader, err, statusCode, message;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          // Check if route changed (this._routeChanged), only if the page is not an error (for validate())
          this._routeChanged = Boolean(app.nuxt.err) || from.name !== to.name;
          this._paramChanged = !this._routeChanged && from.path !== to.path;
          this._queryChanged = !this._paramChanged && from.fullPath !== to.fullPath;
          this._diffQuery = this._queryChanged ? getQueryDiff(to.query, from.query) : [];
          if ((this._routeChanged || this._paramChanged) && this.$loading.start && !this.$loading.manual) {
            this.$loading.start();
          }
          _context2.prev = 5;
          if (!this._queryChanged) {
            _context2.next = 12;
            break;
          }
          _context2.next = 9;
          return resolveRouteComponents(to, function (Component, instance) {
            return {
              Component: Component,
              instance: instance
            };
          });
        case 9:
          Components = _context2.sent;
          // Add a marker on each component that it needs to refresh or not
          startLoader = Components.some(function (_ref2) {
            var Component = _ref2.Component,
              instance = _ref2.instance;
            var watchQuery = Component.options.watchQuery;
            if (watchQuery === true) {
              return true;
            }
            if (Array.isArray(watchQuery)) {
              return watchQuery.some(function (key) {
                return _this3._diffQuery[key];
              });
            }
            if (typeof watchQuery === 'function') {
              return watchQuery.apply(instance, [to.query, from.query]);
            }
            return false;
          });
          if (startLoader && this.$loading.start && !this.$loading.manual) {
            this.$loading.start();
          }
        case 12:
          // Call next()
          next();
          _context2.next = 26;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](5);
          err = _context2.t0 || {};
          statusCode = err.statusCode || err.status || err.response && err.response.status || 500;
          message = err.message || ''; // Handle chunk loading errors
          // This may be due to a new deployment or a network problem
          if (!/^Loading( CSS)? chunk (\d)+ failed\./.test(message)) {
            _context2.next = 23;
            break;
          }
          window.location.reload(true /* skip cache */);
          return _context2.abrupt("return");
        case 23:
          this.error({
            statusCode: statusCode,
            message: message
          });
          this.$nuxt.$emit('routeChanged', to, from, err);
          next();
        case 26:
        case "end":
          return _context2.stop();
      }
    }, _callee2, this, [[5, 15]]);
  }));
  return _loadAsyncComponents.apply(this, arguments);
}
function applySSRData(Component, ssrData) {
  if (NUXT.serverRendered && ssrData) {
    applyAsyncData(Component, ssrData);
  }
  Component._Ctor = Component;
  return Component;
}

// Get matched components
function resolveComponents(router) {
  var path = getLocation(router.options.base, router.options.mode);
  return flatMapComponents(router.match(path), /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(Component, _, match, key, index) {
      var _Component;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof Component === 'function' && !Component.options)) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return Component();
          case 3:
            Component = _context.sent;
          case 4:
            // Sanitize it and save it
            _Component = applySSRData(sanitizeComponent(Component), NUXT.data ? NUXT.data[index] : null);
            match.components[key] = _Component;
            return _context.abrupt("return", _Component);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x4, _x5, _x6, _x7, _x8) {
      return _ref.apply(this, arguments);
    };
  }());
}
function callMiddleware(Components, context, layout) {
  var _this = this;
  var midd = ["nuxt-custom-headers"];
  var unknownMiddleware = false;

  // If layout is undefined, only call global middleware
  if (typeof layout !== 'undefined') {
    midd = []; // Exclude global middleware if layout defined (already called before)
    layout = sanitizeComponent(layout);
    if (layout.options.middleware) {
      midd = midd.concat(layout.options.middleware);
    }
    Components.forEach(function (Component) {
      if (Component.options.middleware) {
        midd = midd.concat(Component.options.middleware);
      }
    });
  }
  midd = midd.map(function (name) {
    if (typeof name === 'function') {
      return name;
    }
    if (typeof middleware[name] !== 'function') {
      unknownMiddleware = true;
      _this.error({
        statusCode: 500,
        message: 'Unknown middleware ' + name
      });
    }
    return middleware[name];
  });
  if (unknownMiddleware) {
    return;
  }
  return middlewareSeries(midd, context);
}
function render(_x9, _x10, _x11) {
  return _render.apply(this, arguments);
} // Fix components format in matched, it's due to code-splitting of vue-router
function _render() {
  _render = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(to, from, next) {
    var _this4 = this;
    var spaFallback, fromMatches, nextCalled, _next, matches, Components, errorLayout, layout, _layout, isValid, _iterator, _step, Component, instances, error, _layout2;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(this._routeChanged === false && this._paramChanged === false && this._queryChanged === false)) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", next());
        case 2:
          // Handle first render on SPA mode
          spaFallback = false;
          if (to === from) {
            _lastPaths = [];
            spaFallback = true;
          } else {
            fromMatches = [];
            _lastPaths = getMatchedComponents(from, fromMatches).map(function (Component, i) {
              return compile(from.matched[fromMatches[i]].path)(from.params);
            });
          }

          // nextCalled is true when redirected
          nextCalled = false;
          _next = function _next(path) {
            if (from.path === path.path && _this4.$loading.finish) {
              _this4.$loading.finish();
            }
            if (from.path !== path.path && _this4.$loading.pause) {
              _this4.$loading.pause();
            }
            if (nextCalled) {
              return;
            }
            nextCalled = true;
            next(path);
          }; // Update context
          _context4.next = 8;
          return setContext(app, {
            route: to,
            from: from,
            next: _next.bind(this)
          });
        case 8:
          this._dateLastError = app.nuxt.dateErr;
          this._hadError = Boolean(app.nuxt.err);

          // Get route's matched components
          matches = [];
          Components = getMatchedComponents(to, matches); // If no Components matched, generate 404
          if (Components.length) {
            _context4.next = 27;
            break;
          }
          _context4.next = 15;
          return callMiddleware.call(this, Components, app.context);
        case 15:
          if (!nextCalled) {
            _context4.next = 17;
            break;
          }
          return _context4.abrupt("return");
        case 17:
          // Load layout for error page
          errorLayout = (NuxtError.options || NuxtError).layout;
          _context4.next = 20;
          return this.loadLayout(typeof errorLayout === 'function' ? errorLayout.call(NuxtError, app.context) : errorLayout);
        case 20:
          layout = _context4.sent;
          _context4.next = 23;
          return callMiddleware.call(this, Components, app.context, layout);
        case 23:
          if (!nextCalled) {
            _context4.next = 25;
            break;
          }
          return _context4.abrupt("return");
        case 25:
          // Show error page
          app.context.error({
            statusCode: 404,
            message: 'This page could not be found'
          });
          return _context4.abrupt("return", next());
        case 27:
          // Update ._data and other properties if hot reloaded
          Components.forEach(function (Component) {
            if (Component._Ctor && Component._Ctor.options) {
              Component.options.asyncData = Component._Ctor.options.asyncData;
              Component.options.fetch = Component._Ctor.options.fetch;
            }
          });

          // Apply transitions
          this.setTransitions(mapTransitions(Components, to, from));
          _context4.prev = 29;
          _context4.next = 32;
          return callMiddleware.call(this, Components, app.context);
        case 32:
          if (!nextCalled) {
            _context4.next = 34;
            break;
          }
          return _context4.abrupt("return");
        case 34:
          if (!app.context._errored) {
            _context4.next = 36;
            break;
          }
          return _context4.abrupt("return", next());
        case 36:
          // Set layout
          _layout = Components[0].options.layout;
          if (typeof _layout === 'function') {
            _layout = _layout(app.context);
          }
          _context4.next = 40;
          return this.loadLayout(_layout);
        case 40:
          _layout = _context4.sent;
          _context4.next = 43;
          return callMiddleware.call(this, Components, app.context, _layout);
        case 43:
          if (!nextCalled) {
            _context4.next = 45;
            break;
          }
          return _context4.abrupt("return");
        case 45:
          if (!app.context._errored) {
            _context4.next = 47;
            break;
          }
          return _context4.abrupt("return", next());
        case 47:
          // Call .validate()
          isValid = true;
          _context4.prev = 48;
          _iterator = _createForOfIteratorHelper(Components);
          _context4.prev = 50;
          _iterator.s();
        case 52:
          if ((_step = _iterator.n()).done) {
            _context4.next = 63;
            break;
          }
          Component = _step.value;
          if (!(typeof Component.options.validate !== 'function')) {
            _context4.next = 56;
            break;
          }
          return _context4.abrupt("continue", 61);
        case 56:
          _context4.next = 58;
          return Component.options.validate(app.context);
        case 58:
          isValid = _context4.sent;
          if (isValid) {
            _context4.next = 61;
            break;
          }
          return _context4.abrupt("break", 63);
        case 61:
          _context4.next = 52;
          break;
        case 63:
          _context4.next = 68;
          break;
        case 65:
          _context4.prev = 65;
          _context4.t0 = _context4["catch"](50);
          _iterator.e(_context4.t0);
        case 68:
          _context4.prev = 68;
          _iterator.f();
          return _context4.finish(68);
        case 71:
          _context4.next = 77;
          break;
        case 73:
          _context4.prev = 73;
          _context4.t1 = _context4["catch"](48);
          // ...If .validate() threw an error
          this.error({
            statusCode: _context4.t1.statusCode || '500',
            message: _context4.t1.message
          });
          return _context4.abrupt("return", next());
        case 77:
          if (isValid) {
            _context4.next = 80;
            break;
          }
          this.error({
            statusCode: 404,
            message: 'This page could not be found'
          });
          return _context4.abrupt("return", next());
        case 80:
          _context4.next = 82;
          return Promise.all(Components.map( /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(Component, i) {
              var childPathChanged, watchParam, watchQuery, promises, hasAsyncData, hasFetch, loadingIncrease, promise, p;
              return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    // Check if only children route changed
                    Component._path = compile(to.matched[matches[i]].path)(to.params);
                    Component._dataRefresh = false;
                    childPathChanged = Component._path !== _lastPaths[i]; // Refresh component (call asyncData & fetch) when:
                    // Route path changed part includes current component
                    // Or route param changed part includes current component and watchParam is not `false`
                    // Or route query is changed and watchQuery returns `true`
                    if (_this4._routeChanged && childPathChanged) {
                      Component._dataRefresh = true;
                    } else if (_this4._paramChanged && childPathChanged) {
                      watchParam = Component.options.watchParam;
                      Component._dataRefresh = watchParam !== false;
                    } else if (_this4._queryChanged) {
                      watchQuery = Component.options.watchQuery;
                      if (watchQuery === true) {
                        Component._dataRefresh = true;
                      } else if (Array.isArray(watchQuery)) {
                        Component._dataRefresh = watchQuery.some(function (key) {
                          return _this4._diffQuery[key];
                        });
                      } else if (typeof watchQuery === 'function') {
                        if (!instances) {
                          instances = getMatchedComponentsInstances(to);
                        }
                        Component._dataRefresh = watchQuery.apply(instances[i], [to.query, from.query]);
                      }
                    }
                    if (!(!_this4._hadError && _this4._isMounted && !Component._dataRefresh)) {
                      _context3.next = 6;
                      break;
                    }
                    return _context3.abrupt("return");
                  case 6:
                    promises = [];
                    hasAsyncData = Component.options.asyncData && typeof Component.options.asyncData === 'function';
                    hasFetch = Boolean(Component.options.fetch) && Component.options.fetch.length;
                    loadingIncrease = hasAsyncData && hasFetch ? 30 : 45; // Call asyncData(context)
                    if (hasAsyncData) {
                      promise = promisify(Component.options.asyncData, app.context);
                      promise.then(function (asyncDataResult) {
                        applyAsyncData(Component, asyncDataResult);
                        if (_this4.$loading.increase) {
                          _this4.$loading.increase(loadingIncrease);
                        }
                      });
                      promises.push(promise);
                    }

                    // Check disabled page loading
                    _this4.$loading.manual = Component.options.loading === false;

                    // Call fetch(context)
                    if (hasFetch) {
                      p = Component.options.fetch(app.context);
                      if (!p || !(p instanceof Promise) && typeof p.then !== 'function') {
                        p = Promise.resolve(p);
                      }
                      p.then(function (fetchResult) {
                        if (_this4.$loading.increase) {
                          _this4.$loading.increase(loadingIncrease);
                        }
                      });
                      promises.push(p);
                    }
                    return _context3.abrupt("return", Promise.all(promises));
                  case 14:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function (_x14, _x15) {
              return _ref3.apply(this, arguments);
            };
          }()));
        case 82:
          // If not redirected
          if (!nextCalled) {
            if (this.$loading.finish && !this.$loading.manual) {
              this.$loading.finish();
            }
            next();
          }
          _context4.next = 99;
          break;
        case 85:
          _context4.prev = 85;
          _context4.t2 = _context4["catch"](29);
          error = _context4.t2 || {};
          if (!(error.message === 'ERR_REDIRECT')) {
            _context4.next = 90;
            break;
          }
          return _context4.abrupt("return", this.$nuxt.$emit('routeChanged', to, from, error));
        case 90:
          _lastPaths = [];
          globalHandleError(error);

          // Load error layout
          _layout2 = (NuxtError.options || NuxtError).layout;
          if (typeof _layout2 === 'function') {
            _layout2 = _layout2(app.context);
          }
          _context4.next = 96;
          return this.loadLayout(_layout2);
        case 96:
          this.error(error);
          this.$nuxt.$emit('routeChanged', to, from, error);
          next();
        case 99:
        case "end":
          return _context4.stop();
      }
    }, _callee4, this, [[29, 85], [48, 73], [50, 65, 68, 71]]);
  }));
  return _render.apply(this, arguments);
}
function normalizeComponents(to, ___) {
  flatMapComponents(to, function (Component, _, match, key) {
    if (_typeof(Component) === 'object' && !Component.options) {
      // Updated via vue-router resolveAsyncComponents()
      Component = Vue.extend(Component);
      Component._Ctor = Component;
      match.components[key] = Component;
    }
    return Component;
  });
}
function setLayoutForNextPage(_x12) {
  return _setLayoutForNextPage.apply(this, arguments);
}
function _setLayoutForNextPage() {
  _setLayoutForNextPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(to) {
    var hasError, layout;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          // Set layout
          hasError = Boolean(this.$options.nuxt.err);
          if (this._hadError && this._dateLastError === this.$options.nuxt.dateErr) {
            hasError = false;
          }
          layout = hasError ? (NuxtError.options || NuxtError).layout : to.matched[0].components.default.options.layout;
          if (typeof layout === 'function') {
            layout = layout(app.context);
          }
          _context5.next = 6;
          return this.loadLayout(layout);
        case 6:
          this.setLayout(layout);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5, this);
  }));
  return _setLayoutForNextPage.apply(this, arguments);
}
function checkForErrors(app) {
  // Hide error component if no error
  if (app._hadError && app._dateLastError === app.$options.nuxt.dateErr) {
    app.error();
  }
}

// When navigating on a different route but the same component is used, Vue.js
// Will not update the instance data, so we have to update $data ourselves
function fixPrepatch(to, ___) {
  var _this2 = this;
  if (this._routeChanged === false && this._paramChanged === false && this._queryChanged === false) {
    return;
  }
  var instances = getMatchedComponentsInstances(to);
  var Components = getMatchedComponents(to);
  var triggerScroll = false;
  Vue.nextTick(function () {
    instances.forEach(function (instance, i) {
      if (!instance || instance._isDestroyed) {
        return;
      }
      if (instance.constructor._dataRefresh && Components[i] === instance.constructor && instance.$vnode.data.keepAlive !== true && typeof instance.constructor.options.data === 'function') {
        var newData = instance.constructor.options.data.call(instance);
        for (var key in newData) {
          Vue.set(instance.$data, key, newData[key]);
        }
        triggerScroll = true;
      }
    });
    if (triggerScroll) {
      // Ensure to trigger scroll event after calling scrollBehavior
      window.$nuxt.$nextTick(function () {
        window.$nuxt.$emit('triggerScroll');
      });
    }
    checkForErrors(_this2);
  });
}
function nuxtReady(_app) {
  window.onNuxtReadyCbs.forEach(function (cb) {
    if (typeof cb === 'function') {
      cb(_app);
    }
  });
  // Special JSDOM
  if (typeof window._onNuxtLoaded === 'function') {
    window._onNuxtLoaded(_app);
  }
  // Add router hooks
  router.afterEach(function (to, from) {
    // Wait for fixPrepatch + $data updates
    Vue.nextTick(function () {
      return _app.$nuxt.$emit('routeChanged', to, from);
    });
  });
}
function mountApp(_x13) {
  return _mountApp.apply(this, arguments);
}
function _mountApp() {
  _mountApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(__app) {
    var _app, layout, mount, Components, clientFirstMount;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          // Set global variables
          app = __app.app;
          router = __app.router;
          store = __app.store;

          // Create Vue instance
          _app = new Vue(app); // Load layout
          layout = NUXT.layout || 'default';
          _context6.next = 7;
          return _app.loadLayout(layout);
        case 7:
          _app.setLayout(layout);

          // Mounts Vue app to DOM element
          mount = function mount() {
            _app.$mount('#__nuxt');

            // Add afterEach router hooks
            router.afterEach(normalizeComponents);
            router.afterEach(setLayoutForNextPage.bind(_app));
            router.afterEach(fixPrepatch.bind(_app));

            // Listen for first Vue update
            Vue.nextTick(function () {
              // Call window.{{globals.readyCallback}} callbacks
              nuxtReady(_app);
            });
          }; // Resolve route components
          _context6.next = 11;
          return Promise.all(resolveComponents(router));
        case 11:
          Components = _context6.sent;
          // Enable transitions
          _app.setTransitions = _app.$options.nuxt.setTransitions.bind(_app);
          if (Components.length) {
            _app.setTransitions(mapTransitions(Components, router.currentRoute));
            _lastPaths = router.currentRoute.matched.map(function (route) {
              return compile(route.path)(router.currentRoute.params);
            });
          }

          // Initialize error handler
          _app.$loading = {}; // To avoid error while _app.$nuxt does not exist
          if (NUXT.error) {
            _app.error(NUXT.error);
          }

          // Add beforeEach router hooks
          router.beforeEach(loadAsyncComponents.bind(_app));
          router.beforeEach(render.bind(_app));

          // Fix in static: remove trailing slash to force hydration
          // Full static, if server-rendered: hydrate, to allow custom redirect to generated page

          // Fix in static: remove trailing slash to force hydration
          if (!(NUXT.serverRendered && isSamePath(NUXT.routePath, _app.context.route.path))) {
            _context6.next = 20;
            break;
          }
          return _context6.abrupt("return", mount());
        case 20:
          // First render on client-side
          clientFirstMount = function clientFirstMount() {
            normalizeComponents(router.currentRoute, router.currentRoute);
            setLayoutForNextPage.call(_app, router.currentRoute);
            checkForErrors(_app);
            // Don't call fixPrepatch.call(_app, router.currentRoute, router.currentRoute) since it's first render
            mount();
          }; // fix: force next tick to avoid having same timestamp when an error happen on spa fallback
          _context6.next = 23;
          return new Promise(function (resolve) {
            return setTimeout(resolve, 0);
          });
        case 23:
          render.call(_app, router.currentRoute, router.currentRoute, function (path) {
            // If not redirected
            if (!path) {
              clientFirstMount();
              return;
            }

            // Add a one-time afterEach hook to
            // mount the app wait for redirect and route gets resolved
            var unregisterHook = router.afterEach(function (to, from) {
              unregisterHook();
              clientFirstMount();
            });

            // Push the path and let route to be resolved
            router.push(path, undefined, function (err) {
              if (err) {
                errorHandler(err);
              }
            });
          });
        case 24:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _mountApp.apply(this, arguments);
}